import { render } from "./App.vue?vue&type=template&id=5ac6e5d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5ac6e5d8&lang=scss"

import exportComponent from "/home/abrakadobr/dev/nodejs/takatan/@bluep-js/example/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__